module.exports = __webpack_public_path__ + "media/images/plans/arrow-down-cff2733a28f24c2e6e62983b44691947.svg";